import React from 'react';

import {
  ActionButton,
} from './style';

interface TableRowActionProps {
  index: number
  onDetails: (index: number) => void
}

const TableRowAction = ({
  // ticket,
  index,
  onDetails,
}: TableRowActionProps): JSX.Element => {
  const onDetailsClick = () => {
    onDetails(index);
  };

  return (
    <ActionButton
      onClick={() => {
        onDetailsClick();
      }}
    >
      Detalhes
    </ActionButton>
  );
};

export default TableRowAction;
